export default "__VITE_ASSET__mXR6cGD6__"